import { getRxStorageIndexedDB } from 'rxdb-premium/plugins/storage-indexeddb';
import { IRxdbAdapterProvider } from '../../../infrastructure/rxdb-adapter-provider.interface';

export class RxdbAdapterProviderMock implements IRxdbAdapterProvider {
	public getAdaptor(): any {
		//	return getRxStoragePouch('memory');
		// we should use the in memory database
		// todo remove buff
		return getRxStorageIndexedDB({ batchSize: 300 });
	}
}
